module.exports = __webpack_public_path__ + "media/images/front/about/aboutdba_point03-2-0c24d44efd6ae7dc206eac9e5ab92303.jpg";